import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useAppSelector } from "@store/store-helper";
import { assignableTeamsSelector } from "@store/teams/teams-selector";
import { TeamEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/** Custom hooks to have util functions for team */
export function useTeamUtils() {
  const $ = _c(12);
  const {
    trackEvent
  } = useTrackEvent();
  const {
    navigateToTeamDetails
  } = useAppNavigation();
  const companyId = useCompanyId();
  const teams = useAppSelector(assignableTeamsSelector);
  let t0;
  if ($[0] !== teams) {
    t0 = function isTeamName(value) {
      return teams.some(team => team.name === value);
    };
    $[0] = teams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isTeamName = t0;
  let t1;
  if ($[2] !== teams) {
    t1 = function getTeamIdByName(teamName) {
      const team_1 = teams.find(team_0 => team_0.name === teamName);
      return team_1?.identity;
    };
    $[2] = teams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getTeamIdByName = t1;
  let t2;
  if ($[4] !== companyId || $[5] !== navigateToTeamDetails || $[6] !== trackEvent) {
    t2 = function openTeamDetails(t3) {
      const {
        teamId,
        numberOfMembers
      } = t3;
      trackEvent({
        name: TeamEvents.openTeam,
        props: {
          teamId,
          numberOfMembers: numberOfMembers ?? ""
        }
      });
      navigateToTeamDetails({
        companyId,
        teamId
      });
    };
    $[4] = companyId;
    $[5] = navigateToTeamDetails;
    $[6] = trackEvent;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const openTeamDetails = t2;
  let t3;
  if ($[8] !== getTeamIdByName || $[9] !== isTeamName || $[10] !== openTeamDetails) {
    t3 = {
      openTeamDetails,
      isTeamName,
      getTeamIdByName
    };
    $[8] = getTeamIdByName;
    $[9] = isTeamName;
    $[10] = openTeamDetails;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}